import { TFunction } from 'i18next';
import { MenuItem } from '~/layout/types/MenuItem';

type MenuItemArg<T> = T extends any ? Omit<T, 'label'> : never;

const createMenuItem = (
  t: TFunction,
  scope: 'sidebar' | 'tabBar',
  { id, ...menuItem }: MenuItemArg<MenuItem>,
) =>
  ({
    ...menuItem,
    id,
    label: t(`navigation:${id}.menu.${scope}.label`),
  }) as MenuItem;

export const iconMap: Record<string, { sf: string; md: string }> = {
  House: { sf: 'house.fill', md: 'home' },
  Bot: { sf: 'bubble.left.fill', md: 'chat' },
  Dumbbell: { sf: 'figure.walk', md: 'fitness_center' },
  Utensils: { sf: 'fork.knife', md: 'restaurant' },
  CircleUser: { sf: 'person.circle.fill', md: 'account_circle' },
};

export const createMainMenu = (
  t: TFunction,
  scope: 'sidebar' | 'tabBar',
): MenuItem[] => [
  createMenuItem(t, scope, {
    href: '/',
    name: '(overview)',
    icon: 'House',
    id: 'home',
  }),
  createMenuItem(t, scope, {
    href: '/workouts',
    name: 'workouts',
    icon: 'Dumbbell',
    id: 'workouts',
  }),
  createMenuItem(t, scope, {
    href: '/meals',
    name: 'meals',
    icon: 'Utensils',
    id: 'meals',
  }),
  createMenuItem(t, scope, {
    href: '/profile',
    // The tab is the `profile` folder-route (a Stack via profile/_layout),
    // matching meals/workouts — so nested screens (body-composition) don't
    // register as their own tab and the profile tab stays focused on them.
    name: 'profile',
    icon: 'CircleUser',
    id: 'profile',
  }),
];
